module.exports = {
  all: [
    'classCode',
    'name',
    'owner.displayName',
    'createdAt',
    'status',
    'graduatedStudentCount',
    'followerCount',
    'ratings.averageRatings',
    'price',
    'indexingPrice',
    'discount',
    'discountExpiredDate',
    'feePercentage',
    'command',
  ],
  recommended: [
    'classCode',
    'name',
    'owner.displayName',
    'createdAt',
    'updatedAt',
    'graduatedStudentCount',
    'ratings.averageRatings',
    'price',
    'indexingPrice',
    'discount',
    'feePercentage',
    'recommendedOrder',
    'command',
  ],
  approved: ['classCode', 'name', 'owner.displayName', 'createdAt', 'updatedAt', 'graduatedStudentCount', 'ratings.averageRatings', 'price', 'indexingPrice', 'discount', 'feePercentage', 'command'],
  pending: ['classCode', 'name', 'owner.displayName', 'price', 'indexingPrice', 'feePercentage', 'createdAt', 'updatedAt', 'rejectMessage'],
  rejected: ['classCode', 'name', 'owner.displayName', 'createdAt', 'price', 'indexingPrice', 'feePercentage', 'updatedAt', 'rejectedDate', 'rejectMessage'],
  closed: ['classCode', 'name', 'owner.displayName', 'createdAt', 'price', 'indexingPrice', 'feePercentage', , 'updatedAt', 'closedDate'],
};
